import base from './base';

const rankingApi = dispatch => {
  return {
    async getRankingByType(type, data) {
      return base.privateApi(dispatch, {
        path: `/ranking/${type}`,
        method: 'post',
        data,
      });
    },
  };
};

export default rankingApi;
